import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=47cc4ea4&scoped=true&"
import script from "./Config.vue?vue&type=script&lang=js&"
export * from "./Config.vue?vue&type=script&lang=js&"
import style0 from "./Config.vue?vue&type=style&index=0&id=47cc4ea4&prod&lang=scss&scoped=true&"
import style1 from "./Config.vue?vue&type=style&index=1&id=47cc4ea4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc4ea4",
  null
  
)

export default component.exports